import { crmRequest } from '../../http'

export type PairReason = 'naam' | 'domein' | 'lijkt_op'

export type MergeField =
  | 'name'
  | 'description'
  | 'website'
  | 'kvk_number'
  | 'email'
  | 'phone'
  | 'street'
  | 'house_number'
  | 'postcode'
  | 'city'
  | 'country'
  | 'linkedin_url'
  | 'category_id'
  | 'owner_user_id'
  | 'status'
  | 'summary_html'
  | 'relation_since'

export interface DuplicateOrganisation {
  id: string
  name: string
  city: string | null
  website: string | null
  domains: string[]
  kvk_number: string | null
  members_count: number
}

export interface DuplicatePair {
  first: DuplicateOrganisation
  second: DuplicateOrganisation
  reason: PairReason
  score: number | null
}

export interface DuplicatePairs {
  items: DuplicatePair[]
  total: number
  more: boolean
}

export interface FieldDifference {
  field: MergeField
  survivor: unknown
  other: unknown
  survivor_text?: string | null
  other_text?: string | null
}

export interface MergeMoves {
  members_moved: number
  members_folded: number
  labels_moved: number
  labels_dropped: number
  activities: number
  agreements: number
  tasks: number
  saved_views: number
}

export interface MergePreview {
  survivor: DuplicateOrganisation
  other: DuplicateOrganisation
  fields: FieldDifference[]
  moves: MergeMoves
  survivor_updated_at: string
  other_updated_at: string
}

export interface MergeRequest {
  survivor_id: string
  other_id: string
  take_from_other: MergeField[]
  expected: { survivor_updated_at: string; other_updated_at: string }
}

export function listDuplicates(): Promise<DuplicatePairs> {
  return crmRequest('/organisations/duplicates')
}

/** Marks two organisations as "geen dubbel"; the backend stores the pair ordered. */
export function markDistinct(firstId: string, secondId: string): Promise<void> {
  return crmRequest('/organisations/distinct', {
    method: 'POST',
    body: JSON.stringify({ first_id: firstId, second_id: secondId }),
  })
}

export function getMergePreview(survivorId: string, otherId: string): Promise<MergePreview> {
  const search = new URLSearchParams({ survivor_id: survivorId, other_id: otherId })
  return crmRequest(`/organisations/merge-preview?${search.toString()}`)
}

/** Merges; the answer is the survivor's detail, of which only the id is used. */
export function mergeOrganisations(input: MergeRequest): Promise<{ id: string; name: string }> {
  return crmRequest('/organisations/merge', { method: 'POST', body: JSON.stringify(input) })
}
